import type { FiltersUpdater } from '@/components/providers/FiltersProvider/filters-provider.types';
import type { FilterComponent } from '@/pages/Workflows/components/organisms/WorkflowFilters/types';
import type { WorkflowsFiltersValues } from '@/pages/Workflows/types/workflows-filter-values';
import { memo } from 'react';

type Props = {
  values: WorkflowsFiltersValues;
  components: FilterComponent[];
  onChange: FiltersUpdater<WorkflowsFiltersValues>;
};

export const WorkflowFilters = memo(({ values, components, onChange }: Props) => {
  return (
    <div className="justify-betwesen flex">
      {components.map(Component => {
        return (
          <div className="w-1/4" key={`filter-component-${Component.displayName}`}>
            <Component filterValues={values} onChange={onChange} />
          </div>
        );
      })}
    </div>
  );
});
